import Cookies from 'js-cookie';
import { clearSession, isAuthenticated, logout } from './authService';
import { refreshSessionIfNeeded } from './apiClient';
import { isSessionStorageKey } from './sessionStore';

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'];
const CHECK_INTERVAL_MS = 30_000;
const DEFAULT_TIMEOUT_MS = 10 * 60 * 1000;

let activityHandler = null;
let intervalId = null;
let lastActivityAt = Date.now();
let refreshDebounceId = null;

export function touchActivity() {
  lastActivityAt = Date.now();

  if (refreshDebounceId) {
    return;
  }

  refreshDebounceId = window.setTimeout(() => {
    refreshDebounceId = null;
    if (isAuthenticated()) {
      refreshSessionIfNeeded();
    }
  }, 1000);
}

export function startSessionWatchdog(timeoutMs = DEFAULT_TIMEOUT_MS) {
  stopSessionWatchdog();
  lastActivityAt = Date.now();

  activityHandler = () => touchActivity();
  ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, activityHandler, { passive: true }));

  intervalId = window.setInterval(() => {
    if (!isAuthenticated()) {
      return;
    }

    if (Date.now() - lastActivityAt > timeoutMs) {
      logout();
      window.location.href = '/';
      return;
    }

    refreshSessionIfNeeded();
  }, CHECK_INTERVAL_MS);
}

export function stopSessionWatchdog() {
  if (activityHandler) {
    ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, activityHandler));
    activityHandler = null;
  }

  if (intervalId) {
    window.clearInterval(intervalId);
    intervalId = null;
  }

  if (refreshDebounceId) {
    window.clearTimeout(refreshDebounceId);
    refreshDebounceId = null;
  }
}

export function handleStorageSync(event) {
  if (!event.key || !isSessionStorageKey(event.key)) {
    return;
  }

  if (!event.newValue) {
    if (Cookies.get('authToken') === 'true') {
      clearSession();
      window.dispatchEvent(new CustomEvent('logout'));
    }
    return;
  }

  if (isAuthenticated()) {
    window.dispatchEvent(new CustomEvent('authenticated'));
  }
}
